module.exports = __webpack_public_path__ + "img/9788983926111.70d5ce6e.jpg";